import { render, staticRenderFns } from "./AuthFooter.vue?vue&type=template&id=77cf65a4&scoped=true&"
import script from "./AuthFooter.vue?vue&type=script&lang=js&"
export * from "./AuthFooter.vue?vue&type=script&lang=js&"
import style0 from "./AuthFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cf65a4",
  null
  
)

export default component.exports